export const MAX_EXTENSIONS_PER_POINT = 2;
